import './HeadingBlock.css';
import sany1 from '../../../assets/images/sany1.webp';
import ScrollableBlock from "../ScrollableBlock/ScrollableBlock";
import useWindowSize from '../../../assets/hooks/useWindowSize';

function HeadingBlock() {
    const window = useWindowSize()

    return (
        <ScrollableBlock>
            <h2 className='about-page__title'>ABOUT SANY</h2>
            <p className="about-page__title_main">
                Founded in&nbsp;2014 by&nbsp;a&nbsp;young and passionate entrepreneur, Sany has grown into a&nbsp;trusted name in&nbsp;the world of&nbsp;luxury watch reselling.
            </p>
            <img alt="" src={sany1} className="about-page__img_first"></img>
            {window.width > 800 ?
                null :
                <p className='about-page__text'>Sany was born from a deep-rooted passion for luxury and craftsmanship, nurtured by a family legacy
                    in the world of fine jewelry. Founded by Rafael, who grew up surrounded by the artistry of his family’s jewelry & watch business, Sany is the culmination of a lifelong love for watches and the timeless
                    elegance they represent.</p>}
        </ScrollableBlock>
    );
}

export default HeadingBlock